import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Calendar as ReactCalendar } from "react-calendar";

import { Styles } from "../../../../../config";
import { observer } from "mobx-react";
import store from "../../../../../store";

const calendarWidth = 325;

const Vessel = styled.div`
  display: ${(props) => (props.open ? "flex" : "none")};
  position: fixed;
  top: ${(props) => {
    return `${props.vesselPosition.top + 40}px`;
  }};
  left: ${(props) => `${props.vesselPosition.right - calendarWidth}px`};
  background: ${Styles.Color.white};
  border-radius: 5px;
  z-index: 1001;
  width: ${calendarWidth}px;

  & * {
  }

  & > button {
    cursor: pointer;
  }

  & > div.react-calendar {
    // box-shadow: 0 24px 38px 3px rgb(127 194 255 / 14%),
    //   0 9px 46px 8px rgb(127 194 255 / 12%), 0 11px 15px -7px rgb(127 194 255 / 20%);
    box-shadow: 0 24px 38px 3px rgb(127 194 255 / 19%),
      0 9px 46px 8px rgb(127 194 255 / 27%),
      0 11px 15px -7px rgb(127 194 255 / 2%);
    border: none;

    z-index: 1001;
  }

  & div.react-calendar__navigation {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  & button.react-calendar__navigation__arrow {
    font-size: 27px;
    width: 30px;
    color: ${Styles.Color.primary};
    cursor: pointer;
    background: ${Styles.Color.white};
  }

  & button.react-calendar__navigation__arrow:disabled {
    background: ${Styles.Color.white}!important;
    color: ${Styles.Color.white}!important;
  }
  & button.react-calendar__navigation__label {
    background: ${Styles.Color.white}!important;
    min-width: 200px;
  }

  & span.react-calendar__navigation__label__labelText {
    font-size: 16px;
    color: ${Styles.Color.primary}!important;
    cursor: pointer;
  }

  & div.react-calendar__navigation {
    margin-bottom: 0;
  }

  & div.react-calendar__month-view__weekdays__weekday {
    text-align: center;
  }

  & div.react-calendar__month-view__weekdays__weekday * {
    text-decoration: none !important;
    color: ${Styles.Color.gray};
    cursor: text;
    text-align: center;
  }

  & button.react-calendar__tile {
    border-radius: 999px;
    height: 42px;
    width: 30px;
    padding: 0 !important;
    background: ${Styles.Color.white};
  }

  & button.react-calendar__tile:hover {
    cursor: pointer;
    background: ${Styles.Color.tertiary};
    color: ${Styles.Color.white}!important;
  }

  & button.react-calendar__tile:hover * {
    color: ${Styles.Color.white}!important;
  }

  & button.react-calendar__tile * {
    color: ${Styles.Color.primary};
    font-size: 14px;
  }

  & button.react-calendar__tile--active {
    background: ${Styles.Color.tertiary}!important;
  }

  & button.react-calendar__tile--active abbr {
    color: ${Styles.Color.white}!important;
  }

  & button.react-calendar__tile--now {
    background: ${Styles.Color.white};
  }

  & button.react-calendar__tile--now:hover {
    background: ${Styles.Color.tertiary};
  }

  & button.react-calendar__tile--now abbr {
    color: ${Styles.Color.primary}!important;
  }

  & button.react-calendar__tile:disabled {
    background: ${Styles.Color.white}!important;
    cursor: not-allowed;
  }
  & button.react-calendar__tile:disabled * {
    color: ${Styles.Color.gray}!important;
  }
`;
const ClickCatcher = styled.div`
  display: ${(props) => (props.open ? "flex" : "none")};
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const Calendar= (props) => {
  const {
    onChange,
    onClose,
    name,
    value,
    onBlur,
    validateForm,
    required: requiredRaw,
    values,
    anchorEl,
  } = props;

  const required =
    typeof requiredRaw === "function" ? requiredRaw({ values }) : requiredRaw;
  const defaultActiveStartDate =
    props.dateConfig?.defaultActiveStartDate || new Date();

  const [vesselPosition, setVesselPosition] = useState({
    top: 0,
    left: 0,
    right: 0,
  });

  useEffect(() => {
    if (props.open && props.anchorEl) {
      const { top, left, right } = props.anchorEl?.getBoundingClientRect();

      let topVal =
        window.innerHeight - top > 300 ? top : top - 300;

      if (top > 0) {
        setVesselPosition({ top: topVal, left, right });
      }
    }
  }, [props.open, store.util.scrollY]);

  const { onDateClick, ...rest } = props.dateConfig;
  return (
    <Vessel vesselPosition={vesselPosition} {...props}>
      <ReactCalendar
        calendarType="US"
        defaultView="month"
        maxDate={required?.max?.value || null}
        minDate={required?.min?.value || null}
        showNeighboringMonth={false}
        {...rest}
        defaultActiveStartDate={defaultActiveStartDate}
        onChange={(value, e) => {
          e.stopPropagation();
          e.preventDefault();
          onChange({ ...e, target: { ...e.target, name, value } }, name, value);
          onDateClick && onDateClick(value, values, validateForm);

          onClose();




        }}
        value={typeof value !== "string" ? value : null}
      ></ReactCalendar>
      <ClickCatcher open={props.open} onClick={() => onClose()}></ClickCatcher>
    </Vessel>
  );
};

export default observer(Calendar);
